export enum WebGameOrientationEnum {
  LANDSCAPE = 'LANDSCAPE',
  VERTICAL = 'VERTICAL',
  BOTH = 'BOTH',
}
